import React, { useEffect } from 'react';
import { CiCircleCheck } from 'react-icons/ci';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { fetchSuccess } from '../redux/slices/successSlice';
import { creatOrder } from '../redux/slices/OrderSlice';

function Success() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let adult = sessionStorage.getItem('adults');
  let date = sessionStorage.getItem('date');
  let startTime = sessionStorage.getItem('selectedTime');
  let price = sessionStorage.getItem('priceFirst');
  let endTime = sessionStorage.getItem('endTime');
  let hours = sessionStorage.getItem('selectedDauer');
  let email = sessionStorage.getItem('email');
  let Vorname = sessionStorage.getItem('Vorname');
  let Telefonnummer = sessionStorage.getItem('Telefonnummer');
  let PLZ = sessionStorage.getItem('PLZ');
  let StraßeHausnummer = sessionStorage.getItem('StraßeHausnummer');
  let Stadt = sessionStorage.getItem('Stadt');
  let name = sessionStorage.getItem('name');

  const [searchParams] = useSearchParams();
  const paymentId = searchParams.get("paymentId");
  const PayerID = searchParams.get("PayerID");

  const { Loading } = useSelector(state => state.success);


  useEffect(() => {
    if (paymentId && PayerID) {
      // إرسال تأكيد الدفع إلى الخادم
      dispatch(fetchSuccess({ paymentId, PayerID }))
        .unwrap()
        .then(() => {
          // استرجاع بيانات الطلب المخزنة
          const pendingOrderData = JSON.parse(sessionStorage.getItem('pendingOrder') || '{}');
          
          if (Object.keys(pendingOrderData).length > 0) {
            // إرسال بيانات الطلب إلى الخادم
            return dispatch(creatOrder({
              ...pendingOrderData,
              paymentId // إضافة معرف الدفع
            })).unwrap();
          }
        })
        .then(() => {
          console.log('Order created successfully');
          toast.success("Die Zahlung war erfolgreich");
          // مسح بيانات الطلب المعلق من sessionStorage
          sessionStorage.removeItem('pendingOrder');
        })
        .catch(error => {
          console.error('Payment confirmation error:', error);
          toast.error("Fehler bei der Zahlungsbestätigung");
        });
    }
  }, [dispatch, paymentId, PayerID]);


  return (
    <div className='h-screen flex flex-col justify-center items-center'>
      {Loading ? (
        <div>Loading...</div>
      ) : (
        <section className='w-1/2 h-1/2 flex flex-col justify-center items-center text-green-500'>
          <CiCircleCheck className='text-9xl' />
          <p className='text-xl font-bold'>Die Zahlung war erfolgreich.</p>
          <button 
            className='mt-4 px-4 py-2 bg-[#a47a24] text-white rounded-lg hover:bg-[#c4a15a]'
            onClick={() => navigate('/')}
          >
            Zurück zur Hauptseite
          </button>
        </section>
      )}
    </div>
  );
}

export default Success;
